/**
 * Registration modes constants
 *
 * @type {}
*/
export const REGISTRATION_MODES = {
    PREREQUISITES: 0,
    MAIN_INFO: 1,
    TIME_INVESTMENT: 2,
    ADDITIONAL_INFO: 3,
    VERIFY_EMAIL: 4
};


// WEBPACK FOOTER //
// ./src/app/register/constants.ts